/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 12H9M17 19H23M23 19L21 17M23 19L21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 13.2857V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21H14M2.5 8H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 8H22V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H8.4C6.15979 21 5.03969 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V8Z"
				fill="currentColor"
			/>
			<path
				d="M22 13.2857V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21H14M2.5 8H21.5M6 12H9M17 19H23M23 19L21 17M23 19L21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M8.367 2.25H15.633C16.7251 2.24999 17.5906 2.24999 18.2883 2.30699C19.0017 2.36527 19.6053 2.48688 20.1565 2.76772C21.0502 3.22312 21.7769 3.94978 22.2323 4.84354C22.5131 5.39472 22.6347 5.99834 22.693 6.71173C22.75 7.40935 22.75 8.27484 22.75 9.36698V13.2857C22.75 13.6999 22.4142 14.0357 22 14.0357C21.5858 14.0357 21.25 13.6999 21.25 13.2857L21.25 9.3163C21.25 8.77868 21.25 8.50988 21.141 8.29598C21.0464 8.1104 20.8895 7.95354 20.7039 7.85899C20.49 7.75 20.2179 7.75 19.6736 7.75H4.32642C3.78211 7.75 3.50996 7.75 3.29606 7.85899C3.11047 7.95354 2.95361 8.1104 2.85904 8.29598C2.75005 8.50988 2.75003 8.77868 2.75 9.3163L2.75 14.6C2.75 15.7325 2.75058 16.5367 2.80201 17.1661C2.85271 17.7867 2.94909 18.171 3.10423 18.4755C3.41582 19.087 3.913 19.5842 4.52453 19.8958C4.829 20.0509 5.21325 20.1473 5.83388 20.198C6.46326 20.2494 7.26752 20.25 8.4 20.25H14C14.4142 20.25 14.75 20.5858 14.75 21C14.75 21.4142 14.4142 21.75 14 21.75H8.36698C7.27484 21.75 6.40935 21.75 5.71173 21.693C4.99834 21.6347 4.39472 21.5131 3.84354 21.2323C2.94978 20.7769 2.22312 20.0502 1.76772 19.1565C1.48688 18.6053 1.36527 18.0017 1.30699 17.2883C1.24999 16.5906 1.24999 15.7251 1.25 14.633V9.367C1.24999 8.27486 1.24999 7.40935 1.30699 6.71173C1.36527 5.99834 1.48688 5.39472 1.76772 4.84354C2.22312 3.94978 2.94978 3.22312 3.84354 2.76772C4.39472 2.48688 4.99834 2.36527 5.71173 2.30699C6.40935 2.24999 7.27486 2.24999 8.367 2.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M21.5303 16.4697C21.2374 16.1768 20.7626 16.1768 20.4697 16.4697C20.1768 16.7626 20.1768 17.2374 20.4697 17.5303L21.1893 18.25H17C16.5858 18.25 16.25 18.5858 16.25 19C16.25 19.4142 16.5858 19.75 17 19.75H21.1893L20.4697 20.4697C20.1768 20.7626 20.1768 21.2374 20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303L23.5303 19.5303C23.8232 19.2374 23.8232 18.7626 23.5303 18.4697L21.5303 16.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 13.2857V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H14.5H14M13 21H8.4C6.15979 21 5.03968 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H9.5H10M2.5 8H18M6 12H9M17 19H23M23 19L21 17M23 19L21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 13.2857V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21H14M2.5 8H21.5M6 12H9M17 19H23M23 19L21 17M23 19L21 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.367 2.25H15.633C16.7251 2.24999 17.5906 2.24999 18.2883 2.30699C19.0017 2.36527 19.6053 2.48688 20.1565 2.76772C21.0502 3.22312 21.7769 3.94978 22.2323 4.84354C22.5131 5.39472 22.6347 5.99834 22.693 6.71173C22.75 7.40935 22.75 8.27484 22.75 9.36698V13.2857C22.75 13.6999 22.4142 14.0357 22 14.0357C21.5858 14.0357 21.25 13.6999 21.25 13.2857L21.25 9.3163C21.25 8.77868 21.25 8.50988 21.141 8.29598C21.0464 8.1104 20.8895 7.95354 20.7039 7.85899C20.49 7.75 20.2179 7.75 19.6736 7.75H4.32642C3.78211 7.75 3.50996 7.75 3.29606 7.85899C3.11047 7.95354 2.95361 8.1104 2.85904 8.29598C2.75005 8.50988 2.75003 8.77868 2.75 9.3163L2.75 14.6C2.75 15.7325 2.75058 16.5367 2.80201 17.1661C2.85271 17.7867 2.94909 18.171 3.10423 18.4755C3.41582 19.087 3.913 19.5842 4.52453 19.8958C4.829 20.0509 5.21325 20.1473 5.83388 20.198C6.46326 20.2494 7.26752 20.25 8.4 20.25H14C14.4142 20.25 14.75 20.5858 14.75 21C14.75 21.4142 14.4142 21.75 14 21.75H8.36698C7.27484 21.75 6.40935 21.75 5.71173 21.693C4.99834 21.6347 4.39472 21.5131 3.84354 21.2323C2.94978 20.7769 2.22312 20.0502 1.76772 19.1565C1.48688 18.6053 1.36527 18.0017 1.30699 17.2883C1.24999 16.5906 1.24999 15.7251 1.25 14.633V9.367C1.24999 8.27486 1.24999 7.40935 1.30699 6.71173C1.36527 5.99834 1.48688 5.39472 1.76772 4.84354C2.22312 3.94978 2.94978 3.22312 3.84354 2.76772C4.39472 2.48688 4.99834 2.36527 5.71173 2.30699C6.40935 2.24999 7.27486 2.24999 8.367 2.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M21.5303 16.4697C21.2374 16.1768 20.7626 16.1768 20.4697 16.4697C20.1768 16.7626 20.1768 17.2374 20.4697 17.5303L21.1893 18.25H17C16.5858 18.25 16.25 18.5858 16.25 19C16.25 19.4142 16.5858 19.75 17 19.75H21.1893L20.4697 20.4697C20.1768 20.7626 20.1768 21.2374 20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303L23.5303 19.5303C23.8232 19.2374 23.8232 18.7626 23.5303 18.4697L21.5303 16.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
